module.exports = __webpack_public_path__ + "static/media/cuidado_perro.68133967.png";